import Immutable from 'seamless-immutable';

import { createReducer, createActions } from 'reduxsauce';
import mergers from 'seamless-immutable-mergers';

export const { Types, Creators } = createActions({
  sendMessage: ['message'],

  whatsAppRequest: ['userData'],
  whatsAppSuccess: ['data'],
  whatsAppFailed: ['error'],
});

const INITIAL_STATE = Immutable({
  messages: [],
  error: {},
  isLoading: false,
  endedChat: false,
});

const whatsAppRequest = (state = INITIAL_STATE) => state.merge({ isLoading: true, error: {} });

const sendMessage = (state = INITIAL_STATE, { message }) =>
  state.merge(
    { messages: [message] },
    {
      merger: mergers.concatArrayMerger,
    }
  );

const whatsAppSuccess = (state = INITIAL_STATE, { data }) =>
  state.merge(data).merge({ isLoading: false, endedChat: true });

const whatsAppFailed = (state = INITIAL_STATE, { error }) => state.merge({ error, isLoading: false, endedChat: true });

export default createReducer(INITIAL_STATE, {
  [Types.SEND_MESSAGE]: sendMessage,

  [Types.WHATS_APP_REQUEST]: whatsAppRequest,
  [Types.WHATS_APP_SUCCESS]: whatsAppSuccess,
  [Types.WHATS_APP_FAILED]: whatsAppFailed,
});
